import classNames from 'classnames';
import View from '../View';
import { forwardRef, useMemo } from 'react';
import styles from './Input.module.scss';

/**
 * Input
 *
 * @return {JSX.Element}
 */
const Input = (
  { className, type, error, fullWidth, reverse, flex, pre, after, ...rest },
  ref
) => {
  const Tag = useMemo(
    () => (type === 'textarea' ? 'textarea' : 'input'),
    [type]
  );

  return (
    <View
      className={classNames(
        styles.Input,
        fullWidth && styles.Input__fullWidth,
        reverse && styles.Input__reverse,
        error && styles.Input__error,
        flex && styles.Input__flex,
        pre && styles.Input__pre,
        className,
        `${Input.displayName}`
      )}
    >
      {pre ? <View className={styles.Pre}>{pre}</View> : null}
      <Tag ref={ref} type={type === 'textarea' ? undefined : type} {...rest} />
      {after ? after : null}
    </View>
  );
};

Input.displayName = 'Input';

export default forwardRef(Input);
